import React from 'react';
import { ValidationProps } from 'ui';
import { ResizeWrapper } from 'app/components/resize-wrapper';
import { TextConfigurationTranslation } from '../../../constants';
import { smResolution } from '../../constants';
import { ListTileColumn } from '../../common/list-tile-column';
import { ModifiedText, TextSearchData } from '../types-store';
import { TextListHolder, TextListItem } from './types';
import { TextListItems } from './text-list-items';
import { TextListTable } from './text-list-table';
import { TextListRow } from './text-list-row';
import { TextListTile } from './text-list-tile';

interface TextListResultsProps {
  textsList: TextSearchData[];
  modifiedTexts: ModifiedText[];
  modifyText: (modifiedText: ModifiedText) => void;
  validation: { [key: string]: ValidationProps };
  translation: TextConfigurationTranslation;
}

const TextListResultsComponent: React.FC<TextListResultsProps> = (props) => {

  const isMobile = (props as TextListResultsProps & { width: number }).width <= smResolution;

  const HolderComponent: TextListHolder = isMobile ? ListTileColumn : TextListTable;
  const ItemComponent: TextListItem = isMobile ? TextListTile : TextListRow;

  return <TextListItems
    HolderComponent={HolderComponent}
    ItemComponent={ItemComponent}
    textsList={props.textsList}
    modifiedTexts={props.modifiedTexts}
    modifyText={props.modifyText}
    validation={props.validation}
    translation={props.translation} />;
};

export const TextListResults: React.FC<TextListResultsProps> = (props) => {
  return <ResizeWrapper>
    <TextListResultsComponent {...props} />
  </ResizeWrapper>;
};
